import { useQuery } from "@tanstack/react-query";
import { getSevenRoomsVenues } from "../../api/bSevenroomsApi";

export const useGetSevenRoomsVenues = (organisationId) => {
  return useQuery({
    queryKey: ["sevenrooms-venues", organisationId],
    queryFn: () => getSevenRoomsVenues(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000,
  });
};
